import {createClasses} from '@minimal/theme/create-classes';

// ----------------------------------------------------------------------

export const logoClasses = {
  root: createClasses('logo__root'),
};
